var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,5 A19,19 0,1 0,24,43 A19,19 0,1 0,24,5",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21,13 H27 V21 H35 V27 H27 V35 H21 V27 H13 V21 H21 Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34,8 L39,13 L36,16 L31,11 Z",
    fill: "#00D4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessAdd);
export default __webpack_public_path__ + "static/media/p4r_business_add.48d882e8c6c1db89e67365a159327d8d.svg";
export { ForwardRef as ReactComponent };